import React, { useState } from "react";
import "./App.css";
import { RouterProvider } from "react-router-dom";
import router from "./pages/router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageSpinner from "./componets/PageSpinner";
import { Provider, useSelector } from "react-redux";
import index from "./store";

export const LoadingContext = React.createContext(null);
export const OpenContext = React.createContext(null);

function App() {
	const [buttonSpinner, setButtonSpinner] = useState([]);
	const [pageSpinner, setPageSpinner] = useState([]);
	const [open, setOpen] = useState(false);
	const { user, token } = useSelector(state => state.user);

	const addButtonSpinner = id => {
		setButtonSpinner(prev => [...prev, id]);
	};

	const removeButtonSpinner = id => {
		setButtonSpinner(prev => prev.filter(el => el !== id));
	};

	const addPageSpinner = id => {
		setPageSpinner(prev => [...prev, id]);
	};

	const removePageSpinner = id => {
		setPageSpinner(prev => prev.filter(el => el !== id));
	};

	return (
		<>
			<Provider store={index}>
				<OpenContext.Provider value={{ open, setOpen }}>
					<LoadingContext.Provider
						value={{
							buttonSpinner,
							pageSpinner,
							addButtonSpinner,
							removeButtonSpinner,
							addPageSpinner,
							removePageSpinner,
						}}>
						<div style={{ marginTop: "60px" }}>
							<RouterProvider router={router(token)} />
						</div>
						<ToastContainer
							theme="light"
							autoClose={2000}
							closeOnClick={true}
						/>
					</LoadingContext.Provider>
				</OpenContext.Provider>
			</Provider>
		</>
	);
}

export default App;
